module.exports = __webpack_public_path__ + "img/A.d1516a7c.png";